import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import Lines from '../components/common/Lines';
import ProgressScroll from '../components/common/ProgressScroll';
import Cursor from '../components/common/cusor';
import LoadingScreen from '../components/common/loader';
import Footer from '../components/common/Footer';
import Navbar from '../components/common/Navbar';
import PageHero from '../components/common/PageHero';
import './legal.css';

export default function TermsAndConditions() {
  const main = useRef();
  const sections = [
    {
      title: 'Use of Our Site',
      paragraphs: [
        'Our website is designed for informational and professional use by creators, models, and affiliated brands. Respect the integrity of our platform by avoiding any misuse, duplication, or distribution of site materials for unauthorized purposes.',
      ],
    },
    {
      title: 'Intellectual Property',
      paragraphs: [
        'All content, branding, and materials on this site—including logos, graphics, copy, and digital downloads—belong exclusively to Profile Management LLC. Written consent is required before reproducing or using any of these assets.',
      ],
    },
    {
      title: 'Communications',
      paragraphs: [
        'By sharing your contact information through our website, forms, or text services, you agree to receive occasional messages, updates, or promotional content from Profile Management LLC.',
      ],
      bullets: [
        {
          label: 'Text Messages',
          text: 'Opt out anytime by replying STOP to any SMS communication.',
        },
        {
          label: 'Email Updates',
          text: 'Use the “unsubscribe” link included in our emails to manage your preferences.',
        },
      ],
    },
    {
      title: 'Creator & Brand Interactions',
      paragraphs: [
        'Profile Management LLC operates as a management and consulting partner. Agreements between creators and third-party brands remain governed by their respective contracts, and Profile is not responsible for the actions or performance of any third party.',
      ],
    },
    {
      title: 'Limitation of Liability',
      paragraphs: [
        'We strive to deliver accurate, up-to-date information. However, Profile Management LLC does not guarantee performance outcomes, platform reliability, or third-party integrations, and we are not liable for losses or damages resulting from use of the site or its content.',
      ],
    },
    {
      title: 'External Links',
      paragraphs: [
        'Our website may include links to third-party sites. Profile Management LLC is not responsible for the privacy practices or content of external websites.',
      ],
    },
    {
      title: 'Changes to These Terms',
      paragraphs: [
        'We may update these Terms and Conditions at any time. Revisions take effect immediately upon posting to this page. We encourage you to review this page periodically to stay informed.',
      ],
    },
    {
      title: 'Contact Us',
      highlight: true,
      paragraphs: ['Have questions about these Terms? Reach our team at the contact details below:'],
      contact: true,
    },
  ];

  return (
    <>
      <Helmet>
        <title>Terms and Conditions | Profile Management LLC</title>
        <link rel="icon" href="/assets/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/assets/imgs/favicon.ico" />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap"
        />
        <script src="/assets/js/gsap.min.js" defer />
        <script src="/assets/js/ScrollTrigger.min.js" defer />
        <script src="/assets/js/ScrollSmoother.min.js" defer />
        <script src="/assets/js/splitting.min.js" defer />
        <script src="/assets/js/isotope.pkgd.min.js" defer />
        <script src="/assets/js/plugins.js" defer />
        <script src="/assets/js/TweenMax.min.js" defer />
        <script src="/assets/js/charming.min.js" defer />
        <script src="/assets/js/countdown.js" defer />
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <Navbar />
        <div id="smooth-wrapper" ref={main}>
          <div id="smooth-content">
            <main className="main-bg o-hidden">
              <PageHero
                title="Terms"
                accent="& Conditions"
                subtitle="Website Use"
                description="Using the Profile Management LLC platform means partnering with us responsibly. Review the guidelines that protect our community and outline how we work together."
              />
              <section className="legal-content">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-lg-9">
                      {sections.map((section, index) => (
                        <div
                          key={section.title}
                          className={`legal-card${section.highlight ? ' highlight' : ''}`}
                        >
                          <span className="legal-step">{String(index + 1).padStart(2, '0')}</span>
                          <h3>{section.title}</h3>
                          {section.paragraphs?.map((paragraph) => (
                            <p key={paragraph}>{paragraph}</p>
                          ))}
                          {section.bullets ? (
                            <ul className="legal-bullets">
                              {section.bullets.map((bullet) => (
                                <li key={bullet.label}>
                                  <span className="legal-bullet-label">{bullet.label}:</span> {bullet.text}
                                </li>
                              ))}
                            </ul>
                          ) : null}
                          {section.contact ? (
                            <div className="legal-contact mt-20">
                              <p>
                                Email: <a href="mailto:accounts@profilemgmt.co">accounts@profilemgmt.co</a>
                              </p>
                              <p>Profile Management LLC — Florida, USA</p>
                            </div>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}


